/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  NOTIFICATION_CLEAN_REQUEST,
  NOTIFICATION_FETCH_REQUEST,
  NOTIFICATION_FETCH_REQUEST_SUCCESS,
  NOTIFICATION_FETCH_REQUEST_FAILURE,
  SINGLE_NOTIFICATION_FETCH_REQUEST,
  SINGLE_NOTIFICATION_FETCH_REQUEST_SUCCESS,
  SINGLE_NOTIFICATION_FETCH_REQUEST_FAILURE,
  DASHBOARD_NOTIFICATION_FETCH_REQUEST,
  DASHBOARD_NOTIFICATION_FETCH_REQUEST_SUCCESS,
  DASHBOARD_NOTIFICATION_FETCH_REQUEST_FAILURE,
  DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST,
  DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST_SUCCESS,
  DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST_FAILURE,
  MARK_NOTIFICATION_AS_READ_REQUEST,
  MARK_NOTIFICATION_AS_READ_REQUEST_SUCCESS,
  MARK_NOTIFICATION_AS_READ_REQUEST_FAILURE,
  NOTIFICATION_PREFERENCE_FETCH_REQUEST,
  NOTIFICATION_PREFERENCE_FETCH_REQUEST_SUCCESS,
  NOTIFICATION_PREFERENCE_FETCH_REQUEST_FAILURE,
} from './type';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  pagination: {},
  errors: {},
  countPayload: [],
  countLoading: false,
  countErrors: {},
  dashboardPayload: [],
  dashboardLoading: false,
  dashboardErrors: {},
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  notificationReadPayload: [],
  notificationReadLoading: false,
  notificationReadErrors: {},
  notificationPreference: {},
  notificationPreferenceLoading: false,
  notificationPreferenceError: {}
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const notificationReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        countLoading: true,
      });

    case DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        countLoading: false,
        countPayload: action.data,
        countErrors: {},
      });

    case DASHBOARD_NOTIFICATION_COUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        countLoading: false,
        countErrors: action.error,
      });

    case NOTIFICATION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case NOTIFICATION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data],
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
              Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
        errors: {},
      });

    case NOTIFICATION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case NOTIFICATION_PREFERENCE_FETCH_REQUEST:
      return Object.assign({}, state, {
        notificationPreferenceLoading: true,
      });

    case NOTIFICATION_PREFERENCE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        notificationPreferenceLoading: false,
        notificationPreference: action.data,
        notificationPreferenceError: {},
      });

    case NOTIFICATION_PREFERENCE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        notificationPreferenceLoading: false,
        notificationPreferenceError: action.error,
      });

    case DASHBOARD_NOTIFICATION_FETCH_REQUEST:
      return Object.assign({}, state, {
        dashboardLoading: true,
      });

    case DASHBOARD_NOTIFICATION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        dashboardPayload: action.data,
        dashboardLoading: false,
        dashboardErrors: {},
      });

    case DASHBOARD_NOTIFICATION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        dashboardLoading: false,
        dashboardErrors: action.error,
      });

    case SINGLE_NOTIFICATION_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case SINGLE_NOTIFICATION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });

    case SINGLE_NOTIFICATION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
      });

    case NOTIFICATION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        pagination: {},
        errors: {},
        singlePayload: [],
        singleLoading: false,
        singleErrors: {},
      });

    case MARK_NOTIFICATION_AS_READ_REQUEST:
      return Object.assign({}, state, {
        notificationReadLoading: true,
      });

    case MARK_NOTIFICATION_AS_READ_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        notificationReadLoading: false,
        notificationReadPayload: action.data,
        notificationReadErrors: {},
      });

    case MARK_NOTIFICATION_AS_READ_REQUEST_FAILURE:
      return Object.assign({}, state, {
        notificationReadLoading: false,
        notificationReadErrors: action.error,
      });
    default:
      return state;
  }
};

export default notificationReducer;
